import { render } from "./NewOrder_Import.vue?vue&type=template&id=90c89a0e"
import script from "./NewOrder_Import.vue?vue&type=script&lang=js"
export * from "./NewOrder_Import.vue?vue&type=script&lang=js"

import "./NewOrder_Import.vue?vue&type=style&index=0&id=90c89a0e&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__